import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=bcda129e&scoped=true"
import script from "./Poll.vue?vue&type=script&lang=js"
export * from "./Poll.vue?vue&type=script&lang=js"
import style0 from "./Poll.vue?vue&type=style&index=0&id=bcda129e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcda129e",
  null
  
)

export default component.exports